export const facebookStatisticsFilters = [
  {
    label: 'Популярные',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'app_id', label: 'Приложения'},
      {value: 'inf_bayer_id', label: 'Байер'},
      {value: 'state', label: 'Состояние'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser_id', label: 'Рекламодатель'},
      {value: 'brand_id', label: 'Бренд'},
      {value: 'offer_id', label: 'Оффер'},
      {value: 'landing_id', label: 'Лендинг'},
    ],
  },
  {
    label: 'Influence',
    options: [
      {value: 'inf_bayer_id', label: 'Байер'},
      {value: 'link_id', label: 'Поток'},
      {value: 'inf_traffic_id', label: 'Блогер'},
    ],
  },
  {
    label: 'Состояние',
    options: [{value: 'state', label: 'Состояние'}],
  },
  {
    label: 'ГЕО',
    options: [{value: 'country_id', label: 'Страна'}],
  },
];
